import React, { Component } from 'react'

export default class API_KEY_TOKEN extends Component {
  render() {

    const { handleInitApi } = this.props
    const { user } = this.props.auth;

    const api_keys = user?.api_keys ? user.api_keys : [];

    const handleCopy = async () => {
      const text = document.getElementById("copyInput").getAttribute("value");
      await navigator.clipboard.writeText(text);
    };

    return (
      <div className="container_project bg_white" style={{ width: "330px" }}>
        <h1 className="text_bold">API key token</h1>
        <br />
        {api_keys.length > 0 ? (
          <section>
            <p className="text_inferior">
              This is your API key, use it to unlock API access
            </p>
            <input id="copyInput" className="text_bold" defaultValue={api_keys[0]?.key} disabled />
            <button className='button background_black marginTop_5' onClick={() => handleCopy()}>Copy</button>
          </section>
        ) : (
          <section>
            <p className="text_inferior">You don't have an API key yet</p>
            <button className="button background_black" onClick={handleInitApi}>
              Create a new API key
            </button>
          </section>
        )}
      </div>
    )
  }
}
